import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { getKnowledgeInfoList } from "@/api/index";
import { modelList } from "@/api/app";
export default {
  state: {
    editNode: {},
    parentNodes: [],
    childNodes: [],
    funcData: {},
    // 功能数据源
    funcPluginList: [],
    // 功能插件数据源
    funcPluginApplicationId: '',
    // 功能插件所属应用
    showDrawerData: {},
    // 展示数据源
    knowledgeList: [],
    // 知识库数据源
    modleOptions: [],
    // 大模型数据
    modleOptionsLoaded: false,
    workFlowType: 'workflow',
    // 工作流类型 workflow 工作流  dialogue 对话流
    dialogueInputLoading: false,
    dialogueLoading: false,
    scrollbarBottom: false,
    messageDom: null,
    tempFileList: [],
    fileUploadList: [],
    fiileUpdateCV: {
      accept: '.png,.jpg,.jpeg',
      suffixArr: ['png', 'jpg', 'jpeg'],
      list: [],
      status: false,
      url: ''
    },
    modelType: '',
    //模型模式（qa,dialogue,text-agent,Workflow,multi_agent）
    mulAgentParams: {} //多模态判断全局条件，场景一致
  },
  mutations: {
    //存放editNode
    setEditNode: function setEditNode(state, val) {
      state.editNode = val;
    },
    setMulAgentParams: function setMulAgentParams(state, obj) {
      state.mulAgentParams[obj.key] = obj.value;
    },
    setParentNodes: function setParentNodes(state, val) {
      state.parentNodes = val;
    },
    setChildNodes: function setChildNodes(state, val) {
      state.childNodes = val;
    },
    setFuncData: function setFuncData(state, val) {
      state.funcData = val;
    },
    setFuncPluginList: function setFuncPluginList(state, val) {
      if (Array.isArray(val)) {
        state.funcPluginList = val;
        state.funcPluginApplicationId = '';
        return;
      }
      state.funcPluginList = (val === null || val === void 0 ? void 0 : val.pluginList) || [];
      state.funcPluginApplicationId = (val === null || val === void 0 ? void 0 : val.applicationId) || '';
    },
    setShowDrawerData: function setShowDrawerData(state, val) {
      state.showDrawerData = val;
    },
    setKnowledgeList: function setKnowledgeList(state, val) {
      state.knowledgeList = val;
    },
    setModleOptions: function setModleOptions(state, val) {
      state.modleOptions = val;
    },
    setModleOptionsLoaded: function setModleOptionsLoaded(state, val) {
      state.modleOptionsLoaded = val;
    },
    setWorkFlowType: function setWorkFlowType(state, val) {
      state.workFlowType = val;
    },
    setmodelType: function setmodelType(state, val) {
      state.modelType = val;
    }
  },
  actions: {
    fetchKnowledgeList: function fetchKnowledgeList(_ref) {
      var commit = _ref.commit;
      getKnowledgeInfoList({
        pageNo: 1,
        pageSize: 1000,
        order: "",
        sort: "",
        ownerType: 'all'
      }).then(function (res) {
        if (res.code === "000000") {
          var _res$data;
          commit('setKnowledgeList', ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.records) || []);
        } else {
          commit('setKnowledgeList', []);
        }
      });
    },
    // 应用板块 获取大模型选择的数据
    fetchModleOptions: function fetchModleOptions(_ref2) {
      var commit = _ref2.commit;
      commit('setModleOptionsLoaded', false);
      return modelList({
        id: "",
        modelId: "",
        modelName: "",
        status: "启用",
        ownerType: 'all'
      }).then(function (res) {
        if (res.code === "000000") {
          var data = (res.data || []).filter(function (item) {
            return item.status !== '禁用';
          });
          commit('setModleOptions', data || []);
        } else {
          commit('setModleOptions', []);
        }
      }).catch(function () {
        commit('setModleOptions', []);
      }).finally(function () {
        commit('setModleOptionsLoaded', true);
      });
    }
  }
};